import { z } from 'zod';
export const loginRequestSchema = z.object({
    username: z.string().max(64),
    password: z.string().max(256),
});
export const registerRequestSchema = z.object({
    username: z.string().max(64),
    displayName: z.string().max(200),
    password: z.string().max(256),
    note: z.string().max(2000).default(''),
});
export const changePasswordRequestSchema = z.object({
    currentPassword: z.string().max(256),
    newPassword: z.string().max(256),
});
//# sourceMappingURL=auth.js.map